import {
  FormPageInputItemSelectionSubtext,
  FormPageInputItemSingleSelectionPulldown,
  FormPagePropertyItemSingleSelection,
} from 'backend';
import {
  FormPageInputData,
  SINGLE_SELECTION_PROPERTY_INPUT_TYPE,
} from 'shared';
import { PropertyItemElement } from '../getPropertyItemElements';
import {
  getSelectionPropertyItemSubtextFormCustomizeQuerySelector,
  getSingleSelectionPulldownFormCustomizeQuerySelector,
} from '../getPropertyItemElements/formCustomize/singleSelection';
import {
  getSelectionPropertyItemSubtextQuerySelector,
  getSingleSelectionPulldownQuerySelector,
} from '../getPropertyItemElements/singleSelection';

export const getSingleSelectionInputValue = (
  propertyItem: FormPagePropertyItemSingleSelection,
  propertyItemElement: PropertyItemElement,
  isFormCustomize: boolean,
): FormPageInputData => {
  switch (propertyItem.inputFormat.inputType) {
    case SINGLE_SELECTION_PROPERTY_INPUT_TYPE.pulldown: {
      const pulldownElement = propertyItemElement.pulldown;
      if (!(pulldownElement instanceof HTMLSelectElement)) {
        return {};
      }
      const inputData = {
        [propertyItem.propertyId]: {
          inputItemType: 'singleSelectionPulldown',
          value: pulldownElement.value
            ? Number(pulldownElement.value)
            : undefined,
        } as FormPageInputItemSingleSelectionPulldown,
      };
      if (!propertyItem.drillDown) {
        return inputData;
      }
      // ドリルダウン設定時、親の選択内容を取得し返す
      const parentPropertyId = propertyItem.drillDown.parentId;
      const parentQuerySelectorFunc = !isFormCustomize
        ? getSingleSelectionPulldownQuerySelector
        : getSingleSelectionPulldownFormCustomizeQuerySelector;
      const parentElement = document.querySelector<HTMLSelectElement>(
        parentQuerySelectorFunc(parentPropertyId),
      );
      if (!parentElement) {
        return inputData;
      }
      inputData[parentPropertyId] = {
        inputItemType: 'singleSelectionPulldown',
        value: parentElement.value ? Number(parentElement.value) : undefined,
      } as FormPageInputItemSingleSelectionPulldown;
      return inputData;
    }
    case SINGLE_SELECTION_PROPERTY_INPUT_TYPE.radio:
    case SINGLE_SELECTION_PROPERTY_INPUT_TYPE.radioHorizontal: {
      const radioElements = propertyItemElement.radios;
      const isAllRadio =
        Array.isArray(radioElements) &&
        radioElements.every(
          (element) =>
            element instanceof HTMLInputElement && element.type === 'radio',
        );

      if (!isAllRadio) {
        return {};
      }
      const checkedValue =
        (radioElements as HTMLInputElement[]).find((element) => element.checked)
          ?.value || null;
      const subtextQuerySelectorFunc = !isFormCustomize
        ? getSelectionPropertyItemSubtextQuerySelector
        : getSelectionPropertyItemSubtextFormCustomizeQuerySelector;
      const subtextValues = propertyItem.candidates
        .filter(
          (candidate) => candidate.subtext != null && candidate.value != null,
        )
        .map((candidate) => {
          const subtextElement = document.querySelector<HTMLInputElement>(
            subtextQuerySelectorFunc(
              propertyItem.propertyId,
              candidate.value ?? 0,
            ),
          );
          return subtextElement
            ? ({
                value: Number(candidate.value),
                subtext: subtextElement.value,
              } as FormPageInputItemSelectionSubtext)
            : null;
        })
        .filter(
          (
            subtextValue,
          ): subtextValue is Exclude<FormPageInputItemSelectionSubtext, null> =>
            subtextValue != null,
        );
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'singleSelectionRadio',
          value: checkedValue ? Number(checkedValue) : undefined,
          subtexts: subtextValues,
        },
      };
    }
  }
};
